define('views/feedback/dialog',[
  "globals",
  "backbone",
  "templates"
], function (globals, Backbone, JST) {
  "use strict";

  return Backbone.View.extend({
    template: JST["app/assets/templates/feedback/thank.html"],

    events: {
      "submit form": "submit"
    },

    initialize: function () {
      globals.content.on("change:location", this.close, this);
      this.$el.on("hidden.bs.modal", _.bind(this.close, this));
    },

    submit: function (e) {
      e.preventDefault();

      this.model.save({
        content: this.$("textarea").val()
      }, {
        patch: true,
        success: _.bind(this.render, this)
      });

      return this;
    },

    render: function () {
      this.$(".modal-body").html(this.template());
      return this;
    },

    close: function () {
      this.trigger("remove").remove();
      return this;
    }
  });
});

